import React from 'react';
import { Alert, Card, CardContent, Grid, Stack, Typography } from '@mui/material';
import { FWizardSummaryCard } from '../wizard';

type Props = { quality?: any };

class ForecastQualityPanel extends React.PureComponent<Props> {
  render() {
    const q = this.props.quality || {};
    const confidence = Number(q.confidence ?? q.forecastconfidence ?? 0);
    const exceptions = Number(q.exceptions ?? q.exceptioncount ?? 0);
    const outliers = Number(q.outliers ?? q.outliercount ?? 0);

    return (
      <Stack spacing={2}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 6, md: 3 }}><FWizardSummaryCard label="Confidence" value={`${confidence}%`} tone={confidence >= 80 ? 'success' : 'warning'} /></Grid>
          <Grid size={{ xs: 6, md: 3 }}><FWizardSummaryCard label="Exceptions" value={exceptions} tone={exceptions ? 'warning' : 'success'} /></Grid>
          <Grid size={{ xs: 6, md: 3 }}><FWizardSummaryCard label="Outliers" value={outliers} tone={outliers ? 'warning' : 'success'} /></Grid>
          <Grid size={{ xs: 6, md: 3 }}><FWizardSummaryCard label="Status" value={q.status || 'DRAFT'} tone={q.status === 'READY' ? 'success' : 'info'} /></Grid>
        </Grid>

        {exceptions || outliers ? <Alert severity="warning">Review exceptions and outliers before publishing this forecast baseline.</Alert> : <Alert severity="success">Forecast quality checks have not detected major issues.</Alert>}

        <Card elevation={1}><CardContent><Typography variant="h6" sx={{ fontWeight: 800 }}>Executive Interpretation</Typography><Typography variant="body2" color="text.secondary">{q.interpretation || 'The forecast baseline appears suitable for review. Add narrative interpretation once backend analytics are finalized.'}</Typography></CardContent></Card>
      </Stack>
    );
  }
}

export default ForecastQualityPanel;
